import { useState } from 'react';

import {
  S9ComponentConfig,
  S9ComponentConfigCategory,
  S9ComponentConfigRelease,
} from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

import { DBDependency } from '../../models/stack9/Dependency';
import { Requirement } from '../../models/stack9/Requirement';
import { DependencyDrawer } from '../DependencyDrawer/DependencyDrawer';

const S9Button = ui.S9Button.default;

const { useRefreshList } = ui;

export const config: S9ComponentConfig = {
  name: 'DependencyAction',
  icon: '',
  category: S9ComponentConfigCategory.GENERAL,
  version: S9ComponentConfigRelease.ALPHA,
  hasState: true,
  allowChildren: false,
  props: [],
};

type DependencyActionProps = {
  row: DBDependency & { requirement: Partial<Requirement> };
};
const DependencyAction = ({ row }: DependencyActionProps) => {
  const refresh = useRefreshList();

  const [drawerState, setDrawerState] = useState<{
    id?: number;
    open: boolean;
  }>({ open: false });

  return (
    <>
      <S9Button
        type="link"
        style={{ width: '100%', textAlign: 'left' }}
        onClick={() => setDrawerState({ id: row.id, open: true })}
        label={`${row.requirement.summary}`}
      />
      <DependencyDrawer
        initialValues={row}
        id={row.id}
        open={drawerState.open}
        onClose={() => {
          setDrawerState({ id: undefined, open: false });
          refresh();
        }}
      />
    </>
  );
};

export default DependencyAction;
